import { OrgRoles } from "@aura-frontend/omnibus-az-client";

import {
  basePermissions,
  OrganizationRoles,
  Role,
  RoleOption,
  RoleOptions,
} from "@/types/roles";

export const getAvailableRoleOptions = (
  roles: Role[] = [],
  hasAccountOwner: boolean,
): RoleOption[] => {
  if (
    roles.some((role) => ["magnus_super_admin", "magnus_admin"].includes(role))
  ) {
    return Object.entries(RoleOptions)
      .filter(([role]) => !(hasAccountOwner && role === "account_owner"))
      .map(([value, label]) => ({ value: value as OrgRoles, label }));
  }

  const allowedRoles = Array.from(
    new Set(
      roles.flatMap((role) => basePermissions[role as OrganizationRoles] || []),
    ),
  );

  return Object.entries(RoleOptions)
    .filter(
      ([role]) =>
        allowedRoles.includes(role as OrgRoles) &&
        !(hasAccountOwner && role === "account_owner"),
    )
    .map(([value, label]) => ({ value: value as OrgRoles, label }));
};
